import { Button } from '@superdispatch/ui-lab';
import { ScreenshotCheckDialog } from '../../../profile/superpay/account-details/ScreenshotCheckDialog';
import {
  UploadScreenshotTitle,
  UploadTransactionScreenshotFormContent,
  useUploadScreenshotStep,
} from '../../../profile/superpay/account-details/UploadTransactionScreenshotForm';
import { MobileDrawerLayout } from './MobileDrawerLayout';

interface UploadScreenshotStepProps {
  onBack: () => void;
  /** Also called when the carrier closes the step during the check. */
  onComplete: () => void;
  onVerified?: () => void;
}

export function UploadScreenshotStep({
  onBack,
  onComplete,
  onVerified,
}: UploadScreenshotStepProps) {
  const {
    formik,
    isCheckDialogOpen,
    closeCheckDialog,
    handleBack,
    submitLabel,
    isSubmitDisabled,
  } = useUploadScreenshotStep({ onBack, onComplete, onVerified });

  return (
    <>
      <MobileDrawerLayout
        formik={formik}
        title={
          <UploadScreenshotTitle>
            Upload Transaction Screenshot
          </UploadScreenshotTitle>
        }
        enableBack={true}
        onBack={handleBack}
        action={
          <Button
            onClick={() => {
              void formik.submitForm();
            }}
            pending={formik.isSubmitting}
            disabled={isSubmitDisabled}
            fullWidth={true}
          >
            {submitLabel}
          </Button>
        }
      >
        <UploadTransactionScreenshotFormContent />
      </MobileDrawerLayout>

      <ScreenshotCheckDialog
        open={isCheckDialogOpen}
        onKeepWaiting={closeCheckDialog}
        onClose={() => {
          closeCheckDialog();
          onComplete();
        }}
      />
    </>
  );
}
